import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { handleUpload } from "utils/ImageUploader";
import SoftImageInput from "components/SoftImageInput";

const Media = forwardRef(({ onChange, initialValues }, ref) => {
  const { t } = useTranslation();

  const [image, setImage] = useState(initialValues?.product_image || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useImperativeHandle(ref, () => ({
    validateForm,
  }));

  const handleImageUpload = async (event) => {
    setError("");
    const file = event.target.files[0];
    if (!file) {
      setError(`${t("Veuillez sélectionner une image")}`);
      return;
    }

    try {
      setLoading(true);
      const imageUrl = await handleUpload(file);
      setImage(imageUrl);
      onChange({ product_image: imageUrl });
    } catch (err) {
      console.error("Error uploading image:", err);
      setError(`${t("Erreur lors de l'upload. Veuillez réessayer.")}`);
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    if (!image) {
      setError(`${t("L'image est requise")}`);
      return false;
    }
    return true;
  };

  return (
    <SoftBox>
      <SoftTypography variant="h5">{t("Média")}</SoftTypography>
      <SoftBox mt={3}>
        <SoftImageInput
          label={t("Image du produit")}
          image={image}
          onChange={handleImageUpload}
          onClear={() => {
            setImage("");
            onChange({ product_image: "" });
          }}
          loading={loading}
        />
      </SoftBox>
      {error && (
        <SoftTypography component="label" variant="caption" color="error">
          {error}
        </SoftTypography>
      )}
    </SoftBox>
  );
});

export default Media;
